import { render, staticRenderFns } from "./PersonnelRecordDetailsNext.vue?vue&type=template&id=7b1c7a41"
import script from "./PersonnelRecordDetailsNext.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports